import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * Alerts are used to communicate a state that affects a system, feature or page.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/alert#usage)
 * - [Props](https://blockparty.endpoint.com/components/alert#props)
 * <br />
 *
 */
const AlertDescription = /*#__PURE__*/forwardRef((props, forwardedRef) => /*#__PURE__*/React__default.createElement(Box, _extends({
  ref: forwardedRef,
  fontSize: "fontSize20",
  lineHeight: "lineHeight20"
}, props)));

export { AlertDescription };
